import {computed, inject, Injectable, signal} from '@angular/core';
import {
  OnboardingStepProgress,
  UserOnboardingApiService
} from "@app/areas/account/onboarding/services/user-onboarding-api.service";
import {take} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class UserOnboardingService {
  hasIncomplete$ = computed(() => {
    const p = this.progress$()
    const notCompleted = p.filter(e => e.progress.status !== 'completed')

    return notCompleted.length > 0
  })

  progress$ = signal<OnboardingStepProgress[]>([])
  loading$ = signal(false)

  private api = inject(UserOnboardingApiService)

  refresh(): void {
    this.loading$.set(true)
    this.api.getProgress()
      .pipe(take(1))
      .subscribe({
        next: res => {
          console.log('res', res)
          this.progress$.set(res)
          this.loading$.set(false)
        },
        error: err => {
          console.log('err', err)
          this.progress$.set([])
          this.loading$.set(false)
        }
      })
  }
}
